// extracted by mini-css-extract-plugin
module.exports = {"image_frame_outer":"ImageFrame-module--image_frame_outer--nhdzt"};